import StarSharpIcon from "@mui/icons-material/StarSharp";
import { List, Paper } from "@mui/material";
import Grid from "@mui/material/Grid";
import Link from "@mui/material/Link";
import { CopyToClipboard } from "components/ui/atoms/CopyToClipboard";
import SectionGrid from "components/ui/atoms/SectionGrid";
import { ColorTag, DefaultTag } from "components/ui/atoms/Tag";
import TypographyWithMiss from "components/ui/atoms/TypographyWithMiss";
import CompanyHitShort from "models/companies/CompanyHitShort";

const PeopleView = ({ people }) => {
  return (
    <Paper sx={{ p: 2 }}>
      <Grid container spacing={1}>
        <SectionGrid title="Email adresses" size={{ xs: 12, md: 6 }}>
          <Grid container spacing={0.5} pb={0.5}>
            {people.email_addresses.map((email_address, index) => (
              <Grid key={email_address}>
                <CopyToClipboard text={email_address}>
                  <DefaultTag
                    key={index}
                    label={email_address}
                    color={
                      email_address === people.best_email_address
                        ? "primary"
                        : "default"
                    }
                    icon={
                      email_address === people.best_email_address ? (
                        <StarSharpIcon sx={{ scale: "0.8" }} />
                      ) : null
                    }
                  />
                </CopyToClipboard>
              </Grid>
            ))}
          </Grid>
        </SectionGrid>
        <SectionGrid title="Phone number" size={{ xs: 12, md: 6 }}>
          <CopyToClipboard text={people.main_phone_number}>
            <TypographyWithMiss
              variant="body2"
              whiteSpace="pre-line"
              isMissing={people.main_phone_number == ""}
            >
              {people.main_phone_number}
            </TypographyWithMiss>
          </CopyToClipboard>
        </SectionGrid>
        <SectionGrid title="Description" size={{ xs: 12, md: 6 }}>
          <TypographyWithMiss
            variant="body2"
            whiteSpace="pre-line"
            isMissing={people.description == ""}
          >
            {people.description}
          </TypographyWithMiss>
        </SectionGrid>
        <SectionGrid title="Classifications" size={{ xs: 12, md: 6 }}>
          <Grid container spacing={0.5} pb={0.5}>
            {people.tags_sectors.map((tagId) => (
              <Grid key={tagId}>
                <ColorTag key={tagId} tagId={tagId} sx={{ maring: 0.5 }} />
              </Grid>
            ))}
          </Grid>
          <Grid container spacing={0.5} pb={0.5}>
            {people.tags_business_models.map((tagId) => (
              <Grid key={tagId}>
                <ColorTag key={tagId} tagId={tagId} sx={{ maring: 0.5 }} />
              </Grid>
            ))}
          </Grid>
        </SectionGrid>
        <SectionGrid title="Companies" size={{ xs: 12, md: 6 }}>
          <TypographyWithMiss isMissing={people.companies.length == 0}>
            <List dense>
              {people.companies.map((company) => (
                <Link
                  to={`/company/${company.id}/`}
                  target="_blank"
                  color="inherit"
                  key={company.id}
                >
                  <CompanyHitShort hit={company} />
                </Link>
              ))}
            </List>
          </TypographyWithMiss>
        </SectionGrid>
      </Grid>
    </Paper>
  );
};

export default PeopleView;
